// 全角数字を半角数字に変換して時間入力を可能にする
const convertNumberFromZenkakuToHankaku = (value: string) => {
  return value.replace(/[０-９]/g, (substring) => {
    return String.fromCharCode(substring.charCodeAt(0) - 0xfee0);
  });
};

export default convertNumberFromZenkakuToHankaku;
